import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import {
  Absolute,
  Inset,
  On,
  Break,
  Flex,
  Stack,
  Space,
} from 'spaced-components'
import { NavbarThemeSwitch } from '../../components/NavbarTheme'
import WhenVisible from '../../components/WhenVisible'
import BackgroundText from '../../components/BackgroundText'
import Parallax from '../../components/Parallax'
import { AutoFade, AutoSlide } from '../../components/Animated'
import Img from '../../components/Img'
import VideoPlayer from '../../components/VideoPlayer'
import GSAPComponent from '../../components/GSAPComponent'

import CaseStudyLayout, {
  Title,
  Box,
  Detail,
  DetailValue,
  Paragraph,
  InfoSection,
} from '../CaseStudyLayout'

import { getProject } from '../../projects'

import Logo from './Logo'
import video from './assets/video.mp4'
import billboard from './assets/billboard.png'
import homepage from './assets/homepage.png'
import house from './assets/house.png'
import iPhone from './assets/iPhone.png'
import monitor from './assets/monitor.png'
import oldParamountLogo from './assets/old-paramount-logo.png'
import newParamountLogo from './assets/new-paramount-logo.svg'
import poster from './assets/poster.png'
import poster02 from './assets/poster02.png'
import stationery from './assets/stationery.png'

const currentProject = getProject('paramount-equity-mortgage')

class ParamountAnimation extends GSAPComponent {
  animate() {
    /* eslint-disable */
    const text = this.ref.querySelector('#p-text')
    const forward = this.ref.querySelector('#p-forward')
    const arrow = this.ref.querySelector('#p-arrow')
    const plus = this.ref.querySelector('#p-plus')
    const letter = this.ref.querySelector('#p-letter')
    const logoSignet = this.ref.querySelector('#p-logo-signet')
    const logoText = this.ref.querySelector('#p-logo-text')

    const tl = new TimelineMax({ paused: true, delay: this.props.delay || 0 })
    this.props.defaultActive && tl.play()

    tl.staggerFrom(
      [text, arrow, forward, plus, letter],
      3,
      {
        transformOrigin: 'center',
        scale: 0.9,
        opacity: 0,
        ease: Power2.easeOut,
      },
      0.5
    )

    tl.staggerTo(
      [text, arrow, forward, plus, letter],
      0.4,
      {
        scale: 0.8,
        opacity: 0,
      },
      0.04
    )

    tl.staggerFrom(
      [logoSignet, logoText],
      1.5,
      {
        transformOrigin: 'center',
        scale: 0.9,
        opacity: 0,
      },
      0.5,
      '-=.4'
    )

    return tl
    /* eslint-enable */
  }

  componentWillReceiveProps(nextProps) {
    nextProps.active && this.animation.play()
  }

  render() {
    return (
      <svg ref={ref => (this.ref = ref)} viewBox="0 0 886.89 343.95">
        <g id="step1" fill="#FFF">
          <path
            id="p-arrow"
            d="M420.6 172.3a.56.56 0 0 0 .1-.18.5.5 0 0 0 .03-.1v-.09l-.01-.07a.52.52 0 0 0-.07-.17l-.05-.07-.03-.04-10.47-10.11a.54.54 0 0 0-.76.01c-.2.22-.2.56.02.76l9.52 9.2h-92.34c-.3 0-.54.24-.54.53 0 .3.24.54.54.54h92.33l-9.52 9.2a.54.54 0 0 0 .38.92c.13 0 .26-.05.37-.15l10.47-10.12v-.01h.02l.02-.04"
          />
          <path
            id="p-plus"
            d="M701.7 171.31h-18.3v-18.4a.6.6 0 0 0-.62-.61.6.6 0 0 0-.61.61v18.4h-18.32a.6.6 0 0 0-.6.62c0 .35.25.6.6.6h18.32v18.32c0 .35.26.61.61.61s.7-.35.61-.7v-18.22h18.32c.35 0 .7-.35.6-.61a.6.6 0 0 0-.6-.62z"
          />
          <path
            id="p-text"
            d="M87.95 128.78v6.53H71v8.05h14.67v6.02H71v14.59h-7.71v-35.2h24.67zm10.26 25.43a6.51 6.51 0 0 0 2.88 4.5c.76.42 1.78.67 2.97.67s2.2-.25 2.97-.67 1.44-1.1 1.95-1.87c.5-.76.85-1.6 1.01-2.63a16.77 16.77 0 0 0 0-5.93 6.58 6.58 0 0 0-1.01-2.63 5.31 5.31 0 0 0-4.92-2.54c-1.19 0-2.2.25-2.97.68s-1.44 1.1-1.86 1.86c-.51.76-.85 1.61-1.02 2.63a17.49 17.49 0 0 0-.25 2.97c-.09 1.01 0 1.95.25 2.96m-6.36-8.56c.6-1.7 1.53-3.05 2.63-4.24a11.78 11.78 0 0 1 4.15-2.71c1.62-.68 3.4-.94 5.43-.94s3.82.34 5.43.94c1.6.68 3.05 1.52 4.15 2.71a10.87 10.87 0 0 1 2.63 4.24c.6 1.7.93 3.48.93 5.51 0 2.04-.33 3.9-.93 5.51s-1.52 3.05-2.63 4.24a12.6 12.6 0 0 1-4.15 2.72c-1.61.59-3.48.93-5.43.93-2.03 0-3.81-.34-5.43-.94a11.4 11.4 0 0 1-6.78-6.95c-.6-1.6-.93-3.47-.93-5.5 0-1.96.25-3.82.93-5.52m36.55-7.2v4.74h.08a8.6 8.6 0 0 1 3.3-3.9 8.9 8.9 0 0 1 4.83-1.53c.43 0 .94.09 1.54.26v6.53c-.34-.09-.77-.09-1.19-.17-.42-.09-.93-.09-1.36-.09-1.27 0-2.37.26-3.22.68s-1.61 1.02-2.12 1.78c-.5.76-.93 1.61-1.19 2.54a12.98 12.98 0 0 0-.34 3.23v11.44h-6.95v-25.43h6.62v-.09zm34.42 25.52l-4.5-17.13h-.16l-4.33 17.12h-7.2l-8.06-25.52h7.38l4.66 17.3h.09l4.24-17.3h6.78l4.32 17.3h.09l4.75-17.3H178l-7.97 25.52h-7.21zm34-12.47c-.25.26-.68.51-1.1.6-.43.17-.93.25-1.44.33l-1.61.26-1.7.25c-.5.09-1.02.26-1.52.43-.51.17-.94.42-1.36.67-.34.26-.68.6-.94 1.02s-.33.93-.33 1.61c0 .6.08 1.19.34 1.61.25.43.5.77.93 1.02.42.25.85.42 1.35.5.51.1 1.1.18 1.62.18 1.35 0 2.45-.26 3.22-.68a5.17 5.17 0 0 0 1.7-1.61c.33-.68.59-1.27.67-1.95.09-.68.09-1.19.09-1.61v-2.63h.08zm-16.1-5.17c.08-1.61.5-2.97 1.26-4.07a8.3 8.3 0 0 1 2.8-2.63c1.1-.68 2.38-1.1 3.73-1.44 1.36-.26 2.8-.43 4.24-.43 1.27 0 2.55.09 3.9.26 1.27.17 2.55.5 3.56 1.02 1.1.5 1.95 1.27 2.63 2.2.68.93 1.02 2.2 1.02 3.73v13.23c0 1.19.08 2.29.17 3.3.17 1.02.34 1.87.68 2.38h-7.13c-.17-.42-.25-.76-.33-1.19s-.17-.85-.17-1.27a8.54 8.54 0 0 1-3.9 2.37c-1.53.43-3.06.68-4.67.68a14.3 14.3 0 0 1-3.39-.42 8.56 8.56 0 0 1-2.8-1.36c-.76-.6-1.44-1.44-1.86-2.37s-.68-2.12-.68-3.4c0-1.44.25-2.62.76-3.56.51-.93 1.19-1.7 1.95-2.2.77-.6 1.7-1.02 2.8-1.27 1.02-.26 2.04-.51 3.14-.68 1.01-.17 2.12-.25 3.13-.42 1.02-.09 1.95-.26 2.72-.43s1.44-.5 1.86-.85.68-.93.68-1.6c0-.77-.08-1.36-.34-1.79s-.6-.76-1.02-1.02a3.64 3.64 0 0 0-1.44-.5c-.5-.09-1.1-.09-1.78-.09-1.35 0-2.46.25-3.22.85-.76.6-1.27 1.61-1.36 2.97h-6.95zm35.18-7.89v4.75h.08a8.6 8.6 0 0 1 3.31-3.9 8.9 8.9 0 0 1 4.83-1.53c.43 0 .94.09 1.53.26v6.53c-.34-.09-.76-.09-1.19-.17-.42-.09-.93-.09-1.35-.09-1.28 0-2.38.26-3.23.68s-1.6 1.02-2.12 1.78c-.5.76-.93 1.61-1.18 2.54a12.98 12.98 0 0 0-.34 3.23v11.44h-6.96v-25.43h6.62v-.09zm29.34 9.67a6.7 6.7 0 0 0-1.02-2.55c-.5-.76-1.1-1.35-1.86-1.78s-1.7-.67-2.89-.67-2.12.25-2.88.67-1.44 1.1-1.87 1.78c-.5.77-.84 1.62-1.01 2.55-.26.93-.34 1.95-.34 3.05 0 1.02.08 1.95.34 2.97a8.2 8.2 0 0 0 1.1 2.63c.5.76 1.19 1.35 1.95 1.86s1.7.68 2.8.68c1.18 0 2.12-.25 2.88-.68s1.36-1.1 1.86-1.86c.43-.77.77-1.61 1.02-2.63.17-1.02.26-2.04.26-3.05 0-1.02-.09-2.04-.34-2.97m.34 12.55a7.23 7.23 0 0 1-3.23 2.97c-1.35.59-2.8.93-4.49.93-1.87 0-3.56-.34-5-1.1s-2.63-1.78-3.56-2.97a14.68 14.68 0 0 1-2.12-4.33c-.51-1.6-.68-3.3-.68-5.08 0-1.7.25-3.4.68-4.92a14.2 14.2 0 0 1 2.12-4.24 10.25 10.25 0 0 1 8.48-4.07c1.52 0 2.96.34 4.32.93a7.99 7.99 0 0 1 3.22 2.8h.09v-12.8h6.95v35.19h-6.62v-3.23h-.17v-.08zm-185.1 18.4v-6.45H89.3v6.45H78.7v28.66h-7.72v-28.66H60.48zm39.09-6.45v13.23h.17a8.24 8.24 0 0 1 3.39-3.22 9.03 9.03 0 0 1 4.07-1.02c1.86 0 3.4.26 4.58.76s2.12 1.2 2.8 2.12 1.18 2.04 1.44 3.31a22 22 0 0 1 .42 4.33v15.68h-6.95V193.4c0-2.12-.34-3.65-1.02-4.67-.68-1.01-1.78-1.52-3.48-1.52-1.86 0-3.3.6-4.15 1.7s-1.27 2.96-1.27 5.59v13.31H92.6v-35.19h6.96zm29.42 35.1h-6.95v-25.43h6.95v25.44zm-7.04-35.1h6.95v5.77h-6.95v-5.77zm19.16 9.67v3.56h.17a7.96 7.96 0 0 1 3.48-3.22 10.08 10.08 0 0 1 4.32-1.02c1.87 0 3.4.26 4.58.76 1.19.51 2.12 1.2 2.8 2.12s1.19 2.04 1.44 3.31a22 22 0 0 1 .43 4.33v15.68h-6.96V193.4c0-2.12-.34-3.65-1.01-4.67-.68-1.01-1.78-1.52-3.48-1.52-1.86 0-3.3.6-4.15 1.7-.85 1.1-1.28 2.96-1.28 5.59v13.31h-6.95v-25.43h6.61v-.1zm30.19-9.67v18.83l8.82-9.16h8.22l-9.58 9.33 10.69 16.1h-8.48L174 196.36l-2.7 2.63v8.74h-7.05v-35.1h7.04zm27.81 35.1h-6.95v-25.43h6.95v25.44zm-7.04-35.1h6.96v5.77h-6.96v-5.77zm19.17 9.67v3.56h.17a7.96 7.96 0 0 1 3.47-3.22 10.08 10.08 0 0 1 4.33-1.02c1.86 0 3.39.26 4.57.76s2.12 1.2 2.8 2.12 1.19 2.04 1.44 3.31a22 22 0 0 1 .43 4.33v15.68h-6.95V193.4c0-2.12-.34-3.65-1.02-4.67-.68-1.01-1.78-1.52-3.48-1.52-1.86 0-3.3.6-4.15 1.7-.85 1.1-1.27 2.96-1.27 5.59v13.31h-6.96v-25.43h6.62v-.1zm37.05 18.82a5.7 5.7 0 0 0 1.86-1.6 7.65 7.65 0 0 0 1.44-4.84c0-1.02-.08-2.04-.25-2.97a5.83 5.83 0 0 0-1.02-2.46 4.86 4.86 0 0 0-1.78-1.7 5.8 5.8 0 0 0-2.88-.67c-1.02 0-1.86.17-2.54.6-.68.42-1.28.92-1.79 1.6-.5.68-.84 1.44-1.01 2.3-.26.84-.34 1.77-.34 2.7s.08 1.87.25 2.72c.17.93.51 1.7.94 2.46a5.11 5.11 0 0 0 1.78 1.78c.76.42 1.6.67 2.71.67 1.02 0 1.87-.16 2.63-.59m9.58 8.48a8.14 8.14 0 0 1-1.78 3.65 11.26 11.26 0 0 1-3.99 2.88 17.68 17.68 0 0 1-6.95 1.19c-1.27 0-2.54-.17-3.82-.51a13.08 13.08 0 0 1-3.56-1.44 8.38 8.38 0 0 1-2.63-2.55 7.48 7.48 0 0 1-1.18-3.73h6.95c.34 1.28.93 2.2 1.95 2.72.93.5 2.04.76 3.3.76 1.96 0 3.4-.6 4.33-1.78a6.57 6.57 0 0 0 1.27-4.5v-3.3h-.08a6.82 6.82 0 0 1-3.22 2.97 9.83 9.83 0 0 1-4.41.93c-1.87 0-3.56-.34-4.92-1.02a9.13 9.13 0 0 1-3.4-2.8 12.93 12.93 0 0 1-1.94-4.07 18.61 18.61 0 0 1 .08-9.66c.51-1.53 1.19-2.89 2.12-4.07a9.85 9.85 0 0 1 3.4-2.8 10.47 10.47 0 0 1 4.66-1.02c1.7 0 3.13.34 4.4.94s2.3 1.7 3.14 3.13h.09v-3.39h6.61v23.83c0 1.18-.17 2.37-.42 3.64"
          />
          <path
            id="p-forward"
            d="M535.96 233.18c-33.7 0-61.12-27.5-61.12-61.2s27.41-61.12 61.12-61.12a61.18 61.18 0 0 1 61.12 61.11c.09 33.71-27.4 61.2-61.12 61.2m0-126.57c-36 0-65.37 29.37-65.37 65.37s29.37 65.38 65.37 65.38c36.1 0 65.38-29.37 65.38-65.38s-29.29-65.37-65.38-65.37m19.58 62.4l-24.26-15.75v15.66l-24.17-15.66v37.54l24.17-15.75v15.75l24.26-15.75v15.75h9.37v-37.54h-9.37v15.74z"
          />
          <path
            id="p-letter"
            d="M798.76 170.17c1.72 0 3.37-.13 4.96-.38 1.59-.25 2.99-.75 4.2-1.48a8.04 8.04 0 0 0 2.9-3.1c.73-1.33 1.1-3.08 1.1-5.24s-.37-3.91-1.1-5.25a8.07 8.07 0 0 0-2.9-3.1c-1.21-.73-2.61-1.22-4.2-1.47a31.52 31.52 0 0 0-4.96-.38h-11.63v20.4h11.63zm4.1-32.04c4.26 0 7.88.62 10.87 1.86a20.37 20.37 0 0 1 7.3 4.91 18.9 18.9 0 0 1 4.1 6.96 25.77 25.77 0 0 1 0 16.16 18.8 18.8 0 0 1-4.1 7.01 20.35 20.35 0 0 1-7.3 4.91c-2.99 1.24-6.61 1.86-10.87 1.86h-15.73v24.41h-14.97v-68.08h30.7z"
          />
        </g>
        <g id="step2">
          <path
            id="p-logo-text"
            fill="#FFF"
            d="M283.96 220.35a15.58 15.58 0 0 1 6.52 5.4c.51.8.98 1.64 1.4 2.52a15.36 15.36 0 0 1 1.15 5.85c0 2.07-.34 3.98-1.03 5.74a12.83 12.83 0 0 1-3.04 4.59 13.78 13.78 0 0 1-5.05 3.1 20.7 20.7 0 0 1-7.12 1.15h-7.57c-.5 0-.92.17-1.26.51-.35.35-.52.77-.52 1.26v8.96c0 .5-.16.91-.49 1.26-.32.34-.73.52-1.23.52h-4.53c-.5 0-.92-.18-1.27-.52a1.72 1.72 0 0 1-.51-1.26v-38.45c0-.5.17-.91.51-1.26.35-.34.77-.52 1.27-.52h16.92c2.03 0 3.98.39 5.85 1.15zm-2.75 20.49a5.78 5.78 0 0 0 3.38-3.96 8.72 8.72 0 0 0-.1-5.63 7 7 0 0 0-1.5-2.46 6.83 6.83 0 0 0-2.41-1.78 7.37 7.37 0 0 0-3.33-.69h-8.03c-.5 0-.92.17-1.26.52-.35.34-.52.76-.52 1.26v11.59c0 .5.17.92.52 1.26.34.34.76.52 1.26.52h8.9c1.14 0 2.17-.21 3.09-.63zm6.25 18.82l19.91-39.77c.23-.46.62-.68 1.15-.68.54 0 .92.23 1.15.68l19.91 39.77c.23.42.26.78.09 1.09-.17.3-.5.46-1 .46h-5.23c-.5 0-1-.16-1.49-.46-.5-.3-.84-.7-1.03-1.15l-1.72-3.44a3.03 3.03 0 0 0-1.07-1.1c-.47-.3-.96-.45-1.46-.45h-16.3c-.5 0-.99.15-1.49.46-.5.3-.84.68-1.03 1.14l-1.66 3.39c-.23.46-.59.84-1.06 1.15-.48.3-.97.46-1.47.46h-5.22c-.5 0-.83-.16-1-.46-.18-.3-.17-.67.02-1.1zm16.82-12.05h8.49c.5 0 .83-.17 1-.5.17-.32.16-.69-.03-1.11l-4.47-9.47c-.2-.46-.44-.69-.75-.69-.3 0-.55.23-.74.7l-4.54 9.46c-.19.46-.19.84 0 1.15.2.3.54.46 1.04.46zm33.68 13.6h-4.53c-.5 0-.92-.18-1.27-.52a1.72 1.72 0 0 1-.51-1.26v-38.45c0-.5.17-.91.51-1.26.35-.34.77-.52 1.26-.52h17.33c2.14 0 4.11.35 5.91 1.04a15.1 15.1 0 0 1 4.54 2.98 13.06 13.06 0 0 1 2.98 4.6c.69 1.8 1.03 3.74 1.03 5.85 0 3.25-.78 6.02-2.35 8.32a13.37 13.37 0 0 1-4.76 4.36c-.42.23-.69.54-.8.94s-.02.8.28 1.18l4.05 5.42c1.28 1.7 2.6 3.51 3.99 5.42.3.42.39.84.25 1.26-.13.43-.45.64-.94.64h-5.8c-.5 0-1.01-.14-1.55-.4-.53-.27-.95-.6-1.26-.98a723.43 723.43 0 0 1-3.84-5.22l-3.8-5.34c-.3-.42-.72-.76-1.25-1.03a3.47 3.47 0 0 0-1.55-.4h-4.42c-.5 0-.92.17-1.26.51-.35.35-.52.77-.52 1.27v9.8c0 .5-.16.92-.49 1.27-.32.34-.74.51-1.23.51zm3.5-20.49h9.3a6.3 6.3 0 0 0 2.23-.46c.84-.3 1.55-.74 2.12-1.32a7.84 7.84 0 0 0 1.5-2.18c.38-.8.57-1.83.57-3.1a11.23 11.23 0 0 0-.57-3.41c-.16-.4-.33-.8-.52-1.18a5.97 5.97 0 0 0-1.95-1.95c-.88-.53-2-.8-3.38-.8h-9.3c-.5 0-.92.17-1.26.51-.35.35-.52.77-.52 1.27v10.84c0 .5.17.92.52 1.26.34.35.76.52 1.26.52zm26 18.94l19.9-39.77c.23-.46.61-.68 1.15-.68.54 0 .92.23 1.15.68l19.9 39.77c.24.42.27.78.1 1.09-.18.3-.51.46-1.01.46h-5.22c-.5 0-1-.16-1.5-.46-.5-.3-.84-.7-1.03-1.15l-1.72-3.44a3.03 3.03 0 0 0-1.06-1.1c-.48-.3-.97-.45-1.46-.45h-16.3c-.5 0-1 .15-1.49.46-.5.3-.84.68-1.03 1.14l-1.67 3.39c-.23.46-.58.84-1.06 1.15-.48.3-.96.46-1.46.46h-5.22c-.5 0-.83-.16-1-.46-.18-.3-.17-.67.02-1.1zm16.8-12.05h8.5c.5 0 .83-.17 1-.5.17-.32.16-.69-.03-1.11l-4.48-9.47c-.19-.46-.44-.69-.74-.69s-.56.23-.75.7l-4.53 9.46c-.2.46-.2.84 0 1.15.19.3.53.46 1.03.46zm71.9-27.43v39.25c0 .5-.18.91-.52 1.26-.34.34-.75.51-1.2.51h-4.54c-.5 0-.92-.17-1.26-.51a1.72 1.72 0 0 1-.52-1.26v-17.68c0-.5-.1-.79-.31-.89-.21-.1-.47.07-.78.5l-10.9 13.02a1.39 1.39 0 0 1-2.24 0l-10.84-13.03c-.3-.38-.58-.53-.8-.46-.23.08-.35.37-.35.86v17.68c0 .5-.17.91-.51 1.26-.35.34-.77.51-1.27.51h-4.47c-.5 0-.92-.17-1.26-.51a1.72 1.72 0 0 1-.52-1.26v-39.25c0-.5.23-.78.69-.86.46-.08.84.08 1.15.46l18.13 22.37c.3.35.69.52 1.15.52.45 0 .84-.17 1.14-.52l18.2-22.37c.3-.38.68-.54 1.14-.46.46.08.69.36.69.86zM483.58 262c-2.98 0-5.8-.58-8.43-1.72a22.16 22.16 0 0 1-11.6-11.6 21.06 21.06 0 0 1-1.71-8.49c0-2.98.57-5.8 1.72-8.46a22.1 22.1 0 0 1 11.59-11.62 20.92 20.92 0 0 1 8.43-1.72c3.02 0 5.86.57 8.5 1.72a22.2 22.2 0 0 1 6.9 4.68 22.12 22.12 0 0 1 4.69 6.94 21.14 21.14 0 0 1 1.72 8.46c0 3.03-.58 5.86-1.72 8.5a22.2 22.2 0 0 1-11.6 11.59 21.06 21.06 0 0 1-8.49 1.72zm.03-36.1c-1.9 0-3.7.4-5.35 1.18a14.6 14.6 0 0 0-8.4 13.11c0 1.92.37 3.73 1.1 5.46.72 1.72 1.7 3.24 2.95 4.56s2.69 2.37 4.35 3.15c1.66.79 3.44 1.18 5.35 1.18 1.9 0 3.7-.4 5.35-1.18a14.3 14.3 0 0 0 4.36-3.15 15.22 15.22 0 0 0 2.94-4.56 13.88 13.88 0 0 0 1.1-5.46 14.76 14.76 0 0 0-4.04-9.98 14.53 14.53 0 0 0-4.36-3.13 12.39 12.39 0 0 0-5.35-1.17zm38.07 34.78a15.98 15.98 0 0 1-5.68-3.56 15.03 15.03 0 0 1-3.67-5.57 19.8 19.8 0 0 1-1.26-7.28v-23.24c0-.5.17-.92.51-1.26.35-.35.75-.52 1.2-.52h4.54c.5 0 .92.17 1.26.52.35.34.52.76.52 1.26v23.18c0 2.1.34 3.85 1.03 5.22a10.49 10.49 0 0 0 2.53 3.27 8.55 8.55 0 0 0 3.27 1.67c.61.15 1.17.26 1.7.34a9.93 9.93 0 0 0 4.55-.34 7.6 7.6 0 0 0 3.27-1.67c1.04-.8 1.9-1.9 2.58-3.27a11.65 11.65 0 0 0 1.04-5.22v-23.18c0-.5.17-.92.51-1.26.35-.35.77-.52 1.27-.52h4.47c.5 0 .92.17 1.26.52.35.34.52.76.52 1.26v23.24c0 1.34-.1 2.6-.32 3.81a19 19 0 0 1-.94 3.47 16.1 16.1 0 0 1-3.62 5.57 16.72 16.72 0 0 1-5.68 3.56 20.62 20.62 0 0 1-7.46 1.26c-2.79 0-5.26-.42-7.4-1.26zm41.2-22.67v21.4c0 .5-.17.92-.52 1.27-.34.34-.76.52-1.26.52h-4.53c-.46 0-.86-.18-1.2-.52a1.72 1.72 0 0 1-.52-1.26v-39.25c0-.5.23-.8.71-.89.48-.1.9.01 1.24.32l25.19 23.8c.38.35.7.47.94.35.25-.11.38-.42.38-.92v-21.8c0-.5.17-.92.51-1.26.34-.35.77-.52 1.26-.52h4.48c.5 0 .92.17 1.26.52.35.34.52.76.52 1.26v39.19c0 .5-.24.8-.72.89-.48.1-.9-.01-1.3-.32l-25.12-23.4c-.39-.31-.7-.4-.95-.3-.25.12-.37.43-.37.92zm62.83-11.7h-8.44c-.5 0-.91.17-1.26.51-.34.35-.52.77-.52 1.27v31.33c0 .5-.17.91-.51 1.26-.35.34-.77.51-1.27.51h-4.47c-.5 0-.92-.17-1.26-.51a1.72 1.72 0 0 1-.52-1.26V228.1c0-.5-.17-.92-.52-1.27a1.72 1.72 0 0 0-1.26-.51h-8.49c-.5 0-.92-.17-1.26-.52s-.52-.76-.52-1.26v-3.56c0-.5.17-.91.52-1.26s.76-.52 1.26-.52h28.52c.5 0 .91.18 1.26.52.34.35.51.77.51 1.26v3.56c0 .5-.17.92-.51 1.26a1.7 1.7 0 0 1-1.26.52zm-365.46 48.05h7.01v1.91h-4.83v2.43h4.26v1.87h-4.26v2.46h5.05v1.92h-7.23v-10.6zm34.8 10.8l-1.45 1.2-1.58-1.82c-.73.35-1.55.55-2.44.55a5.36 5.36 0 0 1-5.48-5.44 5.37 5.37 0 0 1 5.48-5.43c3.05 0 5.48 2.3 5.48 5.43a5.4 5.4 0 0 1-1.5 3.8l1.49 1.7zm-5.66-3.62l1.47-1.2 1.34 1.54c.4-.58.62-1.34.62-2.23 0-1.98-1.3-3.49-3.24-3.49-1.93 0-3.24 1.51-3.24 3.5 0 1.97 1.3 3.48 3.24 3.48.39 0 .75-.05 1.07-.16l-1.26-1.44zm22.66-.42v-6.76h2.18V281c0 1.55.67 2.14 2.12 2.14 1.43 0 2.09-.6 2.09-2.14v-6.63h2.18v6.76c0 2.68-1.85 3.97-4.27 3.97-2.45 0-4.3-1.3-4.3-3.97zm25.96-6.76h2.18v10.59h-2.18v-10.6zm22.02 1.91h-3.02v-1.91h8.22v1.91h-3.02v8.68h-2.18v-8.68zm25.03 4.8l-3.68-6.71h2.45l1.5 2.88c.38.74.85 2 .85 2s.44-1.22.82-2l1.44-2.88h2.24l-3.42 6.55v4.04h-2.2v-3.88zm40.84-6.82h.17l5.22 5.73 5.14-5.73h.19v10.7h-2.1v-3.97c0-.72.08-1.86.08-1.86s-.64.94-1.14 1.5l-2.1 2.35h-.2l-2.11-2.35c-.5-.56-1.14-1.5-1.14-1.5s.08 1.14.08 1.86v3.97h-2.09v-10.7zm27.76 5.4a5.36 5.36 0 0 1 5.48-5.43c3.05 0 5.48 2.3 5.48 5.43a5.36 5.36 0 0 1-5.48 5.44 5.36 5.36 0 0 1-5.48-5.44zm8.72 0c0-1.98-1.3-3.49-3.24-3.49s-3.24 1.51-3.24 3.5c0 1.97 1.3 3.48 3.24 3.48s3.24-1.5 3.24-3.49zm19.28-5.3h3.92c2.17 0 3.95 1.02 3.95 3.5 0 1.6-.85 2.61-2.08 3.1l2.42 4h-2.5l-2.15-3.68h-1.38v3.68h-2.18v-10.6zm3.86 5.08c1.08 0 1.76-.42 1.76-1.58 0-1.19-.71-1.58-1.76-1.58h-1.68v3.16h1.68zm23.3-3.16h-3.02v-1.91h8.22v1.91H511v8.68h-2.18v-8.68zm21 3.38a5.2 5.2 0 0 1 5.41-5.42c1.73 0 2.98.47 3.85 1.47l-1.48 1.46a2.93 2.93 0 0 0-2.37-.96c-1.91 0-3.16 1.47-3.16 3.45 0 1.98 1.28 3.5 3.5 3.5.69 0 1.53-.13 2.08-.4v-1.71h-2.56v-1.92h4.55v4.74c-.6.5-2.13 1.23-4.07 1.23-3.45 0-5.74-2.3-5.74-5.44zm30.63-5.39h.18l4.85 10.69h-2.3l-.58-1.43h-4.12l-.59 1.43h-2.1l4.66-10.69zm1.37 7.43l-.67-1.6c-.3-.7-.6-1.78-.64-1.89-.02.05-.33 1.16-.62 1.89l-.67 1.6h2.6zm18.98-2.04a5.2 5.2 0 0 1 5.4-5.42c1.73 0 2.98.47 3.85 1.47l-1.48 1.46a2.93 2.93 0 0 0-2.36-.96c-1.92 0-3.17 1.47-3.17 3.45 0 1.98 1.28 3.5 3.5 3.5.7 0 1.53-.13 2.08-.4v-1.71h-2.56v-1.92h4.55v4.74c-.6.5-2.13 1.23-4.06 1.23-3.46 0-5.75-2.3-5.75-5.44zm27.05-5.3h7.01v1.92h-4.83v2.43h4.26v1.87h-4.26v2.46h5.05v1.92h-7.23v-10.6z"
          />
          <g id="p-logo-signet">
            <path
              fill="#295FAB"
              d="M417.71 95.05l24.66 16.86-24.66 14.83V141.16l32.73-19.7a10.87 10.87 0 0 0 5.36-9.17 10.84 10.84 0 0 0-4.81-9.45L417.7 80.08V95.05z"
            />
            <linearGradient
              id="SVGID_1_"
              x1="432.57"
              x2="432.57"
              y1="4833.83"
              y2="4850.69"
              gradientTransform="matrix(1 0 0 -1 0 4945.74)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#295FAB" />
              <stop offset=".54" stopColor="#182F58" />
            </linearGradient>
            <path
              fill="url(#SVGID_1_)"
              d="M442.37 111.91l-24.66-16.86 29.71 14.1z"
            />
            <path
              fill="#1C5DB5"
              d="M417.71 141.16V80.08l-13-8.94V167.66c0 4.82 2.41 8.96 6.6 11.33a13.02 13.02 0 0 0 6.4 1.72v-39.55z"
            />
            <path
              fill="#2883EB"
              d="M450.99 102.84l-48.4-33.11-20.16-13.79a11 11 0 0 0-6.22-1.97c-1.8 0-3.54.44-5.2 1.32a10.92 10.92 0 0 0-5.9 9.8v88.13c0 4.1 2.04 7.62 5.62 9.64 1.7.96 3.59 1.47 5.46 1.47 1.97 0 3.94-.56 5.7-1.62l20.99-12.62 14.83-8.93 32.73-19.7a10.87 10.87 0 0 0 5.36-9.17 10.85 10.85 0 0 0-4.81-9.45zm-46.28 31.72l-27.25 16.39V67.52l21.66 14.81 18.6 12.72 24.64 16.86-37.65 22.65z"
            />
            <path
              fill="#1C5DB5"
              d="M516.08 102.18l-91.03-62.27a12.72 12.72 0 0 0-13.4-.78 12.74 12.74 0 0 0-6.94 11.5v20.55l13 8.9V50.64l91.03 62.27-91.03 54.75v-26.5l-13 7.82v18.69c0 4.8 2.41 8.95 6.6 11.32a12.74 12.74 0 0 0 13.1-.18l91.02-54.76a12.66 12.66 0 0 0 6.3-10.77c.14-4.55-1.89-8.53-5.65-11.1z"
            />
            <path
              fill="#1C5DB5"
              d="M404.7 71.18v14.97l13.01 8.9 16.87 11.53 7.79 5.32h-.01v.01l10.79-6.38c.48-.82-1.46-2.2-2.16-2.69L404.73 71.2l-.02-.02z"
            />
            <linearGradient
              id="SVGID_2_"
              x1="411.21"
              x2="411.21"
              y1="4778.08"
              y2="4804.58"
              gradientTransform="matrix(1 0 0 -1 0 4945.74)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".25" stopColor="#295FAB" />
              <stop offset=".38" stopColor="#255396" />
              <stop offset=".71" stopColor="#1C3969" />
              <stop offset=".87" stopColor="#182F58" />
            </linearGradient>
            <path fill="url(#SVGID_2_)" d="M417.71 167.66l-13-18.68 13-7.82z" />
            <linearGradient
              id="SVGID_3_"
              x1="437.13"
              x2="441.52"
              y1="95.77"
              y2="112.14"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".29" stopColor="#295FAB" />
              <stop offset=".42" stopColor="#285CA5" />
              <stop offset=".6" stopColor="#255295" />
              <stop offset=".8" stopColor="#1F437B" />
              <stop offset="1" stopColor="#182F58" />
            </linearGradient>
            <path
              fill="url(#SVGID_3_)"
              d="M442.37 111.91l11.2-6.63s-.96-1.46-3.28-2.92l-10.63-7.27-15.43 4.42 18.13 12.4z"
            />
          </g>
        </g>
      </svg>
    )
  }
}

export default () => (
  <Fragment>
    <Helmet>
      <title>{currentProject.title}</title>
      <meta name="description" content={currentProject.summary} />
    </Helmet>
    <NavbarThemeSwitch theme="dark" />

    <CaseStudyLayout currentProjectKey={currentProject.key} logo={<Logo />}>
      <Box
        css={{
          paddingBottom: '58vw',
          background: `url(${house}) center calc(100% + 5vw) / 111% auto no-repeat #01398e`,
        }}
      >
        <Inset x={{ mobile: 'lg', tabletMd: 0 }}>
          <InfoSection
            text={
              <Fragment>
                <Title is="h1" css={{ maxWidth: '11em' }}>
                  Branding the modern mortgage.
                </Title>
                <Space lg />
                <Paragraph
                  css={{
                    width: { mobile: '100%', tabletMd: '95%', laptop: '90%' },
                  }}
                >
                  Paramount Equity Mortgage set out to revolutionize the
                  mortgage industry in 2003 by delivering a service experience
                  that is fast, easy, friendly and convenient. When comes to
                  choosing a mortgage lender today, the consumer has too many
                  choices. Rational benefits are simply not enough to break from
                  the clutter. In order to succeed, Paramount needed a refined
                  brand positioning - to be a brand that is differentiated and
                  aspirational.
                </Paragraph>
                <Space md />
                <Paragraph
                  css={{
                    width: { mobile: '100%', tabletMd: '95%', laptop: '90%' },
                  }}
                >
                  Paramount’s goal was to stop telling consumers what they do
                  and instead start telling them what they get and how it will
                  make them feel.
                </Paragraph>
              </Fragment>
            }
            details={
              <Stack is="ul" rowGap={15}>
                <li>
                  <Detail muted>Client:</Detail>
                  <Break />
                  <Space xs />
                  <DetailValue>Paramount Equity Mortgage</DetailValue>
                </li>
                <li>
                  <Detail muted>Industry:</Detail>
                  <Break />
                  <Space xs />
                  <DetailValue>Financial</DetailValue>
                </li>
                <li>
                  <Detail muted>Services:</Detail>
                  <Break />
                  <Space xs />
                  <DetailValue>
                    Brand Strategy
                    <Break />
                    Brand Messaging
                    <Break />
                    Brand Identity
                    <Break />
                    Web Design + Development
                  </DetailValue>
                </li>
              </Stack>
            }
          />
        </Inset>
      </Box>
      <Box css={{ backgroundColor: '#0a0a0a' }}>
        <Space xl tabletMd="xxl" />
        <WhenVisible>
          {inView => (
            <Fragment>
              <On min="tabletSm">
                <Space x={{ tabletSm: '-5.55vmax' }}>
                  <Box css={{ width: { tabletMd: '66.666%' }, margin: 'auto' }}>
                    <BackgroundText
                      is="h4"
                      animate={inView}
                      size="12vw"
                      style={{ textAlign: 'left' }}
                    >
                      BRANDING
                    </BackgroundText>
                  </Box>
                </Space>
              </On>
              <Space y={{ tabletSm: '-7vw' }} />
              <Box
                css={{
                  width: '80%',
                  margin: 'auto',
                  textAlign: 'center',
                }}
              >
                <AutoFade>
                  <Title is="h4" css={{ maxWidth: '13em' }}>
                    Thinking forward to make you feel at home.
                  </Title>
                </AutoFade>
                <Space lg />
                <AutoFade>
                  <Paragraph css={{ maxWidth: '41em', margin: 'auto' }}>
                    Paramount’s customers love to think forward about products
                    they want to create or businesses they want to start,
                    careers they want to pursue or worlds they want to explore.
                    We used this mindset to build a refreshed brand identity
                    with a “forward-thinking” strategy, focused on the goals of
                    Paramount’s improved technology-driven lending process.
                  </Paragraph>
                </AutoFade>
              </Box>
            </Fragment>
          )}
        </WhenVisible>
        <Space xl tabletMd={200} />
        <Box
          css={{
            width: { mobile: '80%', tablet: '66.666%' },
            margin: 'auto',
          }}
        >
          <WhenVisible>
            {inView => <ParamountAnimation active={inView} />}
          </WhenVisible>
        </Box>
        <Space xl tabletMd={200} />
        <Box
          css={{
            display: 'flex',
            flexDirection: { mobile: 'column', tablet: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 10%',
            height: '100vh',
            margin: 'auto',
            backgroundColor: '#fff',
            'max:tablet': {
              '> *': {
                width: '100%',
                margin: '8% 0 !important',
                flex: 'initial !important',
              },
            },
          }}
        >
          <AutoFade style={{ flex: 1 }}>
            <Img src={oldParamountLogo} ratio={182 / 563} />
          </AutoFade>
          <On min="tablet" style={{ flex: 0.3, margin: '0 7%' }}>
            <AutoFade delay={1 * 150}>
              <svg viewBox="0 0 94.728 21.309" fill="#bbb">
                <path d="M94.605,10.99c0.028-0.036,0.053-0.073,0.071-0.113c0.012-0.026,0.021-0.051,0.029-0.079c0.009-0.031,0.013-0.061,0.016-0.091c0.003-0.032,0.008-0.062,0.006-0.093c-0.002-0.023-0.01-0.045-0.015-0.069c-0.013-0.061-0.036-0.119-0.07-0.173c-0.016-0.025-0.031-0.05-0.05-0.071c-0.009-0.011-0.014-0.025-0.025-0.035L84.095,0.149c-0.214-0.203-0.554-0.198-0.758,0.015c-0.203,0.214-0.199,0.554,0.015,0.758l9.524,9.196H0.534C0.239,10.118,0,10.357,0,10.652c0,0.296,0.239,0.535,0.534,0.54h92.335l-9.517,9.196c-0.214,0.203-0.219,0.544-0.015,0.758c0.107,0.107,0.244,0.163,0.387,0.163c0.132,0,0.269-0.051,0.371-0.153l10.473-10.117c0.003-0.003,0.005-0.007,0.008-0.009c0.003-0.003,0.005-0.003,0.008-0.006C94.593,11.014,94.597,11.001,94.605,10.99" />
              </svg>
            </AutoFade>
          </On>
          <AutoFade delay={2 * 150} style={{ flex: 1, marginTop: '1%' }}>
            <Img src={newParamountLogo} ratio={89.5 / 372.3} />
          </AutoFade>
        </Box>
        <Box
          css={{
            padding: '11% 15%',
            backgroundColor: '#ddd',
          }}
        >
          <AutoFade>
            <Img src={stationery} ratio={698 / 1243} />
          </AutoFade>
        </Box>
        <AutoFade>
          <Img src={poster02} ratio={1062 / 1737} />
        </AutoFade>
        <AutoFade>
          <Img src={billboard} ratio={1062 / 1737} />
        </AutoFade>
        <Box
          css={{
            backgroundColor: '#01398E',
          }}
        >
          <Space xl tabletMd="xxl" />
          <WhenVisible>
            {inView => (
              <Fragment>
                <On min="tabletSm">
                  <Space x={{ tabletSm: '-5.55vmax' }}>
                    <Box css={{ width: { tabletMd: '70%' }, margin: 'auto' }}>
                      <BackgroundText
                        is="h4"
                        animate={inView}
                        size="12vw"
                        color="#013484"
                        style={{ textAlign: 'left' }}
                      >
                        WEBSITE
                      </BackgroundText>
                    </Box>
                  </Space>
                </On>
                <Space y={{ tabletSm: '-7vw' }} />
                <Box
                  css={{
                    width: '70%',
                    margin: 'auto',
                    position: 'relative',
                    textAlign: 'center',
                  }}
                >
                  <AutoSlide up>
                    <Img src={monitor} ratio={896 / 1207} width="95%" />
                  </AutoSlide>
                  <AutoSlide up delay={200}>
                    <Absolute width="30%" right bottom>
                      <Img src={iPhone} ratio={626 / 360} />
                    </Absolute>
                  </AutoSlide>
                </Box>
              </Fragment>
            )}
          </WhenVisible>
          <Space xl tabletMd="xxl" />
          <AutoSlide up>
            <Box
              css={{
                width: '80%',
                margin: 'auto',
              }}
            >
              <Img src={homepage} ratio={2886 / 1227} />
            </Box>
          </AutoSlide>
          <Space xl tabletMd="xxl" />
        </Box>
        <Space xl tabletMd="xxl" />
        <AutoSlide up>
          <Box
            css={{
              width: '80%',
              margin: 'auto',
              boxShadow: '0 20px 50px rgba(0, 0, 0, .3)',
            }}
          >
            <VideoPlayer poster={poster} video={video} ratio={1080 / 1920} />
          </Box>
        </AutoSlide>
        <Space xl tabletMd="xxl" />
      </Box>
      <Parallax direction="both" height="70vh" maxHeight={600}>
        <Parallax.Background height="150%">
          <Box css={{ height: '100%', backgroundColor: '#01398e' }}>
            <Box
              css={{
                width: { mobile: '180%', tabletLg: '120%' },
                position: 'relative',
                top: { mobile: '60%', tabletLg: '30%' },
                left: 0,
              }}
            >
              <svg viewBox="0 0 30.543 27.891" fill="#002f75" width="40%">
                <path d="M30.184,13.381c-0.188-0.314-0.441-0.584-0.744-0.79L11.66,0.451c-0.771-0.542-1.782-0.6-2.61-0.15	C8.213,0.732,7.69,1.599,7.7,2.541v3.988L7.31,6.261l-3.95-2.68c-0.355-0.248-0.777-0.384-1.21-0.39	c-0.349,0.006-0.692,0.096-1,0.26C0.436,3.818-0.009,4.558,0,5.361v17.17c-0.012,0.783,0.412,1.507,1.1,1.88	c0.322,0.187,0.687,0.287,1.06,0.29c0.393-0.001,0.777-0.112,1.11-0.32l4.04-2.46l0.39-0.235v0.025l2.53-1.53v-0.018l6.35-3.822	c1.019-0.599,1.359-1.911,0.76-2.929c-0.055-0.093-0.125-0.174-0.193-0.258c-0.047-0.158-0.317-0.357-0.427-0.433l-6.49-4.455V2.541	l17.74,12.14l-17.74,10.67v-5.17l-2.53,2.19v2.98c0.001,0.195,0.028,0.382,0.071,0.564c0.023,0.103,0.058,0.2,0.094,0.298	c0.028,0.076,0.058,0.151,0.093,0.223c0.05,0.104,0.101,0.205,0.165,0.301c0.042,0.063,0.092,0.119,0.139,0.178	c0.101,0.126,0.209,0.241,0.334,0.346c0.103,0.088,0.211,0.17,0.327,0.241c0.024,0.014,0.042,0.035,0.066,0.049	c0.037,0.022,0.079,0.03,0.117,0.05c0.098,0.049,0.198,0.092,0.303,0.128c0.1,0.036,0.198,0.069,0.301,0.092	c0.051,0.011,0.104,0.013,0.155,0.021c0.121,0.019,0.24,0.049,0.364,0.049v-0.014c0.008,0,0.014,0.002,0.022,0.002	c0.454-0.002,0.898-0.126,1.288-0.358l17.77-10.67C30.51,16.134,30.901,14.581,30.184,13.381z M2.39,22.091V5.831l4.22,2.89	L7.7,9.468v9.433L2.39,22.091z M15.04,14.481l-4.81,2.896v-2.696v-3.48l4.21,2.88l0.021-0.006l0.009,0.006l2.627-0.82L15.04,14.481z	" />
              </svg>
            </Box>
          </Box>
        </Parallax.Background>
        <Parallax.Content>
          <Flex height="100%" center middle>
            <Inset x={{ mobile: 'lg', tabletMd: 0 }}>
              <Title
                is="blockquote"
                css={{ maxWidth: '18em', textAlign: 'center' }}
              >
                After the launch of our brand campaign, Paramount gained success
                as competitors left the business. They were recently acquired by
                online financial company, Loanpal.
              </Title>
            </Inset>
          </Flex>
        </Parallax.Content>
      </Parallax>
    </CaseStudyLayout>
  </Fragment>
)
